'use client'

import ReactMarkdown, { Components } from 'react-markdown'
import { MarkdownTracker } from './types'
import './markdown.scss'

function MarkdownComponents({
  tracker,
  overrides,
}: {
  tracker?: MarkdownTracker
  overrides?: Components
}): Components {
  return {
    a(anchorProps) {
      const { children, href, ...rest } = anchorProps

      return (
        <a
          {...rest}
          href={href}
          className='markdown__link'
          target='blank'
          rel='noopener'
          onClick={() => {
            if (
              typeof href === 'string' &&
              typeof children === 'string' &&
              tracker
            ) {
              tracker({ children, href })
            }
          }}
        >
          {children}
          <span className='sr-only'>Opens in a new window</span>
        </a>
      )
    },
    ...overrides,
  }
}

interface IMarkdownProps {
  children: string
  tracker?: MarkdownTracker
  overrides?: Components
}

export default function Markdown({
  children,
  overrides,
  tracker,
}: IMarkdownProps) {
  return (
    <div className='markdown'>
      <ReactMarkdown components={MarkdownComponents({ overrides, tracker })}>
        {children}
      </ReactMarkdown>
    </div>
  )
}
